import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import CampaignToolbar from "./CampaignToolbar";

const CampaignToolbarContainer = (props) => {
    // get props
    const {hasFilters, launch, method, recipients = 0, save, schedule, tab, wizardSaving, ...rest} = props;

    // use state
    const [showLaunchDialog, setShowLaunchDialog] = useState(false);
    const [showScheduleDialog, setShowScheduleDialog] = useState(false);

    return <CampaignToolbar {...rest}
                            displayLaunchDialog={() => setShowLaunchDialog(true)}
                            displayScheduleDialog={() => setShowScheduleDialog(true)}
                            hasFilters={hasFilters}
                            hideLaunchDialog={() => setShowLaunchDialog(false)}
                            hideScheduleDialog={() => setShowScheduleDialog(false)}
                            launch={launch}
                            method={method}
                            recipients={recipients}
                            schedule={schedule}
                            showLaunchDialog={showLaunchDialog}
                            showScheduleDialog={showScheduleDialog}
                            save={save}
                            wizardSaving={wizardSaving}
                            tab={tab}/>;
};

CampaignToolbarContainer.propTypes = {
    hasFilters: PropTypes.bool,
    launch: PropTypes.func,
    method: PropTypes.string,
    recipients: PropTypes.number,
    save: PropTypes.func.isRequired,
    schedule: PropTypes.func,
    tab: PropTypes.number.isRequired,
    wizardSaving: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => {
    const campaign = state.campaign && state.campaign.campaign;
    const filters = campaign && campaign.filters;
    return {
        hasFilters: Boolean(campaign && campaign.enableFilters) && Array.isArray(filters) && filters.length > 0,
    };
};

export default connect(mapStateToProps)(CampaignToolbarContainer);
